// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'use_custom_events' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */
let $returnFocusCart = null;
document.addEventListener("click", function (evt) {
  //add to cart clicked
  if (
    evt.target.closest(
      ".header__cart-link,.product-item__quick-add, .product-form__cart-submit",
    )
  ) {
    if (evt.target.closest("[role=dialog]")) {
      return;
    }
    console.log("Last cart open cliked");
    $returnFocusCart = document.activeElement;
  }
});

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
  Rebuy.Cart.fetchCart();
});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  // console.log("Product variant changed");
  // console.log(evt.detail.variant);

  const variantId = evt?.detail?.variant?.id;
  const variantUpdater = VariantUpdater ? new VariantUpdater(variantId) : null;

  // If the variant updater is not available, return early
  if (!variantUpdater) {
    console.log("VariantUpdater is not available");
    return;
  }

  // TODO: Review case for MODAL only (metafields, title, description, etc)

  // Update the variant metafield and SEO information on PDP
  VariantUpdater.updateVariantMetaInformation(variantId);
  VariantUpdater.updateSelectedBundle(variantId, evt?.detail?.variant);
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
});

document.addEventListener("rebuy:smartcart.show", function (event) {
  console.log("Rebuy cart");
  setTimeout(() => {
    const $focusRebuyCart = document.querySelector(
      "#rebuy-cart .rebuy-cart__checkout-button, .rebuy-cart__flyout-empty-cart a",
    );
    tryToFocus($focusRebuyCart, 3);
    console.log("Rebuy focus cart", $focusRebuyCart);
  }, 200);
});

document.addEventListener("rebuy:smartcart.hide", (event) => {
  $returnFocusCart?.focus();
  console.log("Rebuy cart before show, returned to", $returnFocusCart);
});
/* eslint-enable no-console */

function tryToFocus($element, tries = 4) {
  if (!$element || tries <= 0) {
    return;
  }
  $element.focus();
  if (document.activeElement !== $element) {
    setTimeout(() => {
      tryToFocus($element, tries - 1);
    }, 200);
  }
}

/**
 * Keeps the sticky CTA in sync with the PDP Attentive waitlist
 * Shows the waitlist only for eligible variants and proxies clicks to Attentive's single PDP button
 * Keeps Attentive's completed-signup confirmation visible in the sticky bar
 * Observes Attentive because its button mounts asynchronously after consent
 */
(function initStickyAttentiveWaitlist() {
  const eligibilityElement = document.getElementById(
    "attn-waitlist-eligibility",
  );
  const waitlistTrigger = document.getElementById("attn-waitlist-trigger");
  const stickyWaitlistButton = document.querySelector(
    "[data-sticky-attn-waitlist]",
  );
  const stickyAtcButton = stickyWaitlistButton
    ? stickyWaitlistButton
        .closest(".sticky-atc-bar__button")
        ?.querySelector("[data-add-to-cart]")
    : null;

  if (
    !eligibilityElement ||
    !waitlistTrigger ||
    !stickyWaitlistButton ||
    !stickyAtcButton
  ) {
    return;
  }

  let eligibility;
  try {
    eligibility = JSON.parse(eligibilityElement.textContent);
  } catch (error) {
    return;
  }

  let currentVariantId = document.querySelector(
    "[data-product-form][data-current-product-id]",
  )?.dataset.currentProductId;

  function getSourceButton() {
    return waitlistTrigger.querySelector("button");
  }

  function updateStickyWaitlist() {
    const sourceButton = getSourceButton();
    const isEligible = Boolean(
      currentVariantId && eligibility[String(currentVariantId)],
    );
    const sourceButtonEnabled = Boolean(
      sourceButton &&
      !sourceButton.disabled &&
      sourceButton.getAttribute("aria-disabled") !== "true",
    );
    const signupComplete = sourceButton?.dataset.signupComplete === "true";
    const showWaitlist = isEligible && (sourceButtonEnabled || signupComplete);
    const stickyWaitlistDisabled = !showWaitlist || !sourceButtonEnabled;

    stickyAtcButton.hidden = showWaitlist;
    stickyWaitlistButton.hidden = !showWaitlist;
    stickyWaitlistButton.disabled = stickyWaitlistDisabled;
    stickyWaitlistButton.setAttribute(
      "aria-disabled",
      String(stickyWaitlistDisabled),
    );

    if (!showWaitlist) return null;

    const label =
      sourceButton.getAttribute("aria-label") ||
      sourceButton.textContent.trim();
    if (label) {
      stickyWaitlistButton.textContent = label;
      stickyWaitlistButton.setAttribute("aria-label", label);
    }

    return sourceButton;
  }

  stickyWaitlistButton.addEventListener("click", function () {
    updateStickyWaitlist()?.click();
  });

  document.addEventListener("product:variant-change", function (event) {
    currentVariantId = event.detail?.variant?.id || null;
    updateStickyWaitlist();
  });

  updateStickyWaitlist();

  new MutationObserver(updateStickyWaitlist).observe(waitlistTrigger, {
    attributes: true,
    attributeFilter: [
      "aria-disabled",
      "aria-label",
      "data-signup-complete",
      "disabled",
    ],
    childList: true,
    subtree: true,
  });
})();
